import { api } from "./api";
import store from "../store";

export async function atualizarLogNegoc(body) {
    try {
        // Acessa o Vuex: Despacha uma action ou faz commit em uma mutation
        //  console.log("atualizarLogNegoc", body);
        await store.dispatch('insereLogNegoc', body)
        // console.log("atualizarLogNegoc2", body);
        await api.post("Logs/inserelognegoc", body);

        // Exemplo de leitura direta do state se necessário:
        // console.log('Estado atualizado no Vuex:', store.state.logNegoc)

    } catch (erro) {
        console.error('Erro no fluxo:')
    }
}